/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import { LocalSettingManager } from 'biewangle'
import i18n from '../../i18n'
import { hillo } from 'hillo'
import IKUtils from 'innerken-js-utils'
import { enterStore } from '@/model/dataLayer/api/SaaS/storeService'
import Utils from '@/model/utils/IkUtils/Utils'
import store from '@/model/global/store'

const defaultConfig = require('@/assets/config.json')

/**
 * 应用初始化完成的标记。
 * 刷新页面时 Firebase 恢复登录状态、进入门店（initHillo）都是异步的，
 * 在它们完成之前挂载页面，页面里的请求会打到错误的地址，导致整页没有数据。
 * 路由守卫会等待这个 Promise，保证页面在门店初始化完成后再渲染。
 */
let resolveAppInitialized
let appInitializedFlag = false
export const appInitialized = new Promise(resolve => { resolveAppInitialized = resolve })

export function markAppInitialized () {
  if (appInitializedFlag) {
    return
  }
  appInitializedFlag = true
  resolveAppInitialized()
}

export function isAppInitialized () {
  return appInitializedFlag
}

export let NeededKeys = []
const GlobalConfig = Object.assign({
  isShowOnTable: localStorage.getItem('isShowOnTable') || '0',
  UseDailyZbon: localStorage.getItem('UseDailyZbon') || '0'
}, defaultConfig)

export async function loadConfig () {
  Object.assign(GlobalConfig)
  NeededKeys = GlobalConfig.neededKeys
  window.Config = GlobalConfig
  GlobalConfig.getLang = function () {
    return Remember.lang
  }
  if (requireOfflineMode()) {
    await enterStore('')
  }
  if (requireAdminMode() === '1') {
    GlobalConfig.mode = 'Admin'
  }
  IKUtils.init(i18n)
  console.log('GlobalConfig base', hillo.axios.defaults)
}

export function requireOfflineMode () {
  return !!IKUtils.getQueryString('Base')
}

export function requireAdminMode () {
  return IKUtils.getQueryString('Admin')
}

export function getOfflineUrl () {
  return (location.protocol === 'https:' ? 'https' : 'http') + '://' + IKUtils.getQueryString('Base')
}

export function changeLanguage (lang) {
  const l = lang.toLowerCase()
  const backServerLang = ['de', 'zh', 'en']
  localStorage.setItem('frontEndLang', l)
  if (backServerLang.includes(l)) {
    Remember.lang = l
  } else {
    Remember.lang = 'de'
  }
  i18n.locale = l
}

export function isRestaurant () {
  return Remember.restaurantVersion
}

export function getNgrokUrl (deviceId) {
  return `${location.protocol}//ik${deviceId.toString().padStart(4, '0')}.ngrok.aaden.io`
}

let _rootUrl = ''

export async function initHillo (deviceId, url) {
  GlobalConfig.DeviceId = deviceId
  // hillo.initial(url + '/PHP/')
  hillo.use({
    isDebug: false,
    productionUrl: url + '/PHP/',
    debugUrl: url + '/PHP/',
    header: {
      post: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    },
    LoadingUtils: {
      showLoading: Utils.showLoading,
      hideLoading: () => Utils.toast('', 'ok'),
      showError: (tips) => {
        store.commit('showTipsDialog', { tipsMessage: tips || 'Etwas ist schief gelaufen!' })
      }
    }
  })
  _rootUrl = url + '/'
  markAppInitialized()
}

export function getRootUrl () {
  return _rootUrl
}

export const Remember = LocalSettingManager.config({
  defaultDeviceIdList: [],
  pw: '',
  lastLoginEmail: '',
  offlineMode: false,
  softwareType: 'Restaurant',
  activeZBon: false,
  activeXBon: false,
  deliveryList: false,
  sendEmail: false,
  mergeBills: false,
  totalTime: false,
  totalSales: false,
  showGraph: false,
  onlyCharged: true,
  restaurantVersion: 1,
  readAgHint: false,
  readItemHint: false,
  showStorageManagement: 0,
  locale: 'zh',
  lang: 'zh',
  useTimelineView: 0,
  currentUserId: '',
  currencySymbols: '€',
  shouldWait5Seconds: false,
  cardTerminalIP: '',
  cardTerminalPort: ''
})
export const GlobalConfigLang = Remember
export default GlobalConfig
